import {
  Package,
  Globe,
  ShoppingCart,
  Wallet,
  Clock,
  Phone,
} from "lucide-react";
import { Facebook } from "react-feather";
import Image from "next/image";

const Footer = () => {
  return (
    <footer
      id="contact"
      className="bg-cargo-slate text-primary-foreground pt-16 pb-8"
    >
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          {/* Services */}
          <div className="animate-fade-up">
            <h3 className="text-lg font-bold text-primary mb-4">
              МАНАЙ ҮЙЛЧИЛГЭЭ
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Globe className="w-5 h-5 text-primary" />
                <span>БНХАУ-ын бүх хот мужуудаас шуурхай тээвэр</span>
              </li>
              <li className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <ShoppingCart className="w-5 h-5 text-primary" />
                <span>Хятадын онлайн шопуудаас захиалга хийх сургалт</span>
              </li>
              <li className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Wallet className="w-5 h-5 text-primary" />
                <span>Alipay, Wechat юаны шилжүүлэг</span>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div className="animate-fade-up delay-100">
            <h3 className="text-lg font-bold text-primary mb-4">
              АЖИЛЛАХ ЦАГИЙН ХУВААРЬ
            </h3>
            <div className="flex items-center gap-3 text-primary-foreground/80">
              <Clock className="w-5 h-5 text-primary" />
              <span>
                Даваа-Баасан: 9:00-16:30 <br />
                Бямба: 13:00-17:00 <br />
                Ням: Амарна
              </span>
            </div>
          </div>

          {/* Contact */}
          <div className="animate-fade-up delay-200">
            <h3 className="text-lg font-bold text-primary mb-4">
              ХОЛБОО БАРИХ
            </h3>
            <a
              href="tel:77407404"
              className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary transition-colors"
            >
              <Phone className="w-5 h-5 text-primary" />
              <span className="text-lg">77407404</span>
            </a>
            <a
              href="https://www.facebook.com/groups/804013064937859"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary transition-colors"
            >
              <Facebook className="w-5 h-5 text-primary" />
              <span className="text-lg ">Facebook групд нэгдэх</span>
            </a>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <Image
                width={70}
                height={70}
                src={"/mainLogo.jpg"}
                alt=""
                objectFit={"cover"}
                className="rounded-sm"
              />
              <span className="font-bold">Egshu cargo</span>
            </div>
            <p className="text-sm text-primary-foreground/60">
              ©2026 ЗОХИОГЧИЙН ЭРХ ХУУЛИАР ХАМГААЛАГДСАН
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
